import {FC} from "react";
import {useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {CallbackRequestTemplate} from "../../../lib/src/api/repositories/telephone-repository";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const DeleteCallbackTemplateModal: FC<{ callbackRequest: CallbackRequestTemplate, onFinished: () => void }> = (props) => {
  const { telephone } = useApiCall(config)
  const {showToast} = useToasts()

  const submit = async () => {
    await telephone.deleteCallbackTemplate(props.callbackRequest.id).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het verwijderen van een terugbel sjabloon.')
    })
    props.onFinished()
  }

  return <div>
    <div>Weet je zeker dat je het volgende terugbel sjabloon wilt verwijderen?</div>
    <div className={'font-semibold'}>&middot; {props.callbackRequest.name}</div>
    <ModalFooter text={'Verwijderen'} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}